import React from 'react'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'

import SetPassword from '@/components/composite/SetPassword'
import {withTitle} from '@/router/utils'

import {IChangeOldPasswordStore} from './IChangeOldPasswordStore'

export const ChangeOldPasswordStoreSymbol = Symbol('ChangeOldPasswordStore')

const ChangeOldPassword = observer(() => {
    const store = useInjection<IChangeOldPasswordStore>(ChangeOldPasswordStoreSymbol)

    const formId = 'change-old-password'

    return <SetPassword store={store} formId={formId} />
})

export default withTitle(ChangeOldPassword)
